import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vehicle-inspection',
  templateUrl: './vehicle-inspection.component.html',
  styleUrls: ['./vehicle-inspection.component.scss']
})
export class VehicleInspectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  VehicleTotal = [
    {
        "InspectionNo": "2019201235",
        "Vehicle": "Image",
        "VehicleType": "Mercedes Heavey Truck",
        "LicencePlate": "KA 01 MK 2008",
        "Date": "10-10-2018",
        "ReviewedBy": "Lamrath"
    },{
      "InspectionNo": "2019201238",
      "Vehicle": "Image",
        "VehicleType": "Mercedes Heavey Truck",
        "LicencePlate": "KA 01 MK 2008",
        "Date": "10-10-2018",
        "ReviewedBy": "Lamrath"
  },{
    "InspectionNo": "2019201240",
    "Vehicle": "Image",
    "VehicleType": "Mercedes Heavey Truck",
    "LicencePlate": "KA 01 MK 2008",
    "Date": "10-10-2018",
    "ReviewedBy": "Lamrath"
},{
  "InspectionNo": "2019201245",
  "Vehicle": "Image",
  "VehicleType": "Mercedes Heavey Truck",
  "LicencePlate": "KA 01 MK 2008",
  "Date": "10-10-2018",
  "ReviewedBy": "Lamrath"
}
  ]


}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/fleet-management/vehicle-inspection/vehicle-inspection.component.ts